export default {"src":"/_next/static/media/Early-Payment.09a84ad3.svg","height":30,"width":26};